var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"formatter-key-value-container"},_vm._l((_vm.parsed),function(kv,index){return _c('div',{key:index,staticClass:"formatter-key-value-item"},[_vm._v("\n    "+_vm._s(kv)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }